"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionsController = void 0;
class ActionsController {
    constructor() {
        this.isSubscribed = (subscriber) => {
            let isExist = false;
            if (this.subscribers) {
                isExist = this.subscribers.some((item) => {
                    return item.type === subscriber.type && item.handler === subscriber.handler;
                });
            }
            return isExist;
        };
        // Add new subscription and return unSubscribe method
        this.performSubscribe = (subscriber) => {
            // Check if type and handler contains valid values, if not, skip subscription process and
            if (!subscriber.type || !subscriber.handler) {
                return null;
            }
            // if a subscriber not exist add new one to list with subscribers
            if (!this.isSubscribed(subscriber)) {
                this.addNewSubscriber(subscriber);
            }
            // return unSubscribe method
            return this.unSubscribe.bind(this, subscriber);
        };
        this.performUnSubscribe = (subscriber) => {
            // Filter out subscriber by type and handler from list of subscribers
            // if handler is null filter out all subscribers for passed type
            if (subscriber.type && this.subscribers) {
                const filteredSubscribers = this.subscribers.filter(item => {
                    return (item.type !== subscriber.type ||
                        (subscriber.handler && item.handler !== subscriber.handler));
                });
                if (this.subscribers.length === filteredSubscribers.length) {
                    // tslint:disable-next-line:no-console
                    console.warn(`Can't unsubscribe. Subscriber('s) with type=${subscriber.type}
                ${subscriber.handler ? 'and handler=' + subscriber.handler : ''} not found.`);
                }
                this.subscribers = filteredSubscribers;
            }
        };
        this.addNewSubscriber = (subscriber) => {
            // Initialize subscribers list if it's empty
            if (!this.subscribers) {
                this.subscribers = [];
            }
            // Add new subscriber to list
            this.subscribers.push(subscriber);
        };
        this.getSubscribersByType = (type) => {
            let result = null;
            if (type && this.subscribers) {
                result = this.subscribers.filter(item => item.type === type);
            }
            return result && result.length > 0 ? result : null;
        };
    }
    subscribe(source) {
        let result = null;
        if (Array.isArray(source)) {
            result = source.map(this.performSubscribe);
        }
        else {
            result = this.performSubscribe(source);
        }
        return result;
    }
    unSubscribe(source) {
        if (Array.isArray(source)) {
            source.forEach(this.performUnSubscribe);
        }
        else {
            this.performUnSubscribe(source);
        }
    }
    // Execute matched subscribers handlers with action data witch are presented in subscribers list
    // return true if matched subscribers found otherwise return false
    dispatch(action) {
        // Find all subscribers by action type
        const subscribers = this.getSubscribersByType(action.type);
        // if subscribers found execute theirs handles with acton data and return true
        if (subscribers) {
            subscribers.forEach(item => {
                item.handler(action.data);
            });
            return true;
        }
        return false;
    }
}
const actionController = new ActionsController();
exports.ActionsController = actionController;
